import { render, staticRenderFns } from "./urgeCenter.vue?vue&type=template&id=03054765&scoped=true&"
import script from "./urgeCenter.vue?vue&type=script&lang=js&"
export * from "./urgeCenter.vue?vue&type=script&lang=js&"
import style0 from "./urgeCenter.vue?vue&type=style&index=0&id=03054765&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03054765",
  null
  
)

export default component.exports